import { Box, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import HeaderLine from 'src/Common/ui/HeaderLine'
import Input from 'src/Common/ui/input'
import { t } from 'i18next'
import { RxCross2 } from 'react-icons/rx'
import { LiaSaveSolid } from 'react-icons/lia'
import { Button } from '../../Common/ui/button'
import { toast } from 'react-toastify'
import { useIssueStore } from './store/IssueStore'
import { createIssueLessonLearnt } from 'src/API/IssueApi'
import { cn } from 'src/lib/utils'
import Textarea from 'src/Common/ui/textArea'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'

const IssuePendingEdit = ({ handleAddRisk, setIsEditTrue }) => {
    const { control, errors, register } = useForm()
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const { getIssueDetailsById } = useIssueStore()
    const userId = localStorage.getItem('userId')
    const [ formData, setFormData ] = useState({})

    useEffect(() => {
        if (issueDetailsData?.lessonLearntResponse) {
            const data = issueDetailsData?.lessonLearntResponse
            data.status = issueDetailsData?.issueInformation?.status
            data.createdBy = userId
            data.modifiedBy = userId
            setFormData(data)
        }
    }, [issueDetailsData])

    const onInputChange = (key, e, type = 'input') => {
        setFormData({ ...formData, [key]: type === 'input' ? e.target.value : e })
    }

    // const orgId = localStorage.getItem('orgId')
    const [ loading, setLoading ] = useState(false)

    const onSubmit = (message) => {
        setLoading(true)
        const data = JSON.parse(JSON.stringify(formData))
        createIssueLessonLearnt(data).then((res) => {
            if (res?.data) {
                toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message.replace('[ID]', issueDetailsData?.issueInformation?.referenceId)}</p></p>, {
                    position: 'top-right', theme: 'light'
                })
                handleAddRisk({ status: STATUS_ENUMS.Completed }, 'Issue [ID] pending for review completed')
                getIssueDetailsById(Number(issueDetailsData?.issueInformation?.id), userId)
                setIsEditTrue(false)
                setLoading(false)
            } else {
                toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>End Date should be lesser than Resolution Date</p></p>, {
                    position: 'top-right', hideProgressBar: true, theme: 'light'
                })
                setLoading(false)
            }
        })
    }

    const handleCancel = () => {
        setIsEditTrue(false)
    }

    return (

        <div className='h-[100%] w-[100%]'>
            <Card className="flex flex-col h-[100%] gap-4 p-4 flex-shrink-0">
                <div className='h-[90%] flex flex-col gap-8 !overflow-scroll'>
                    <HeaderLine text={'Lessons Plan'} />
                    <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                        <Box gridColumn="span 1" className='pl-1'>
                            <Input
                                errors={errors}
                                control={control}
                                rules={{
                                    // validate: (value) => {
                                    //     return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                    // }s
                                }}
                                name='breif-description'
                                label={t('Monitory Benefit')}
                                placeholder="Enter Monitory Benefit"
                                type="number"
                                onValueChange={(e) => { onInputChange('monitoryBenefit', e) }}
                                value={formData?.monitoryBenefit}
                                maxLength={250}
                            />
                        </Box>
                        <Box gridColumn="span 1">
                            <p className='text-subHeading-2 text-[hsl(var(--primary))] font-bold'>TurnAroundTime</p>
                            <p>{formData?.turnAroundTime}</p>
                        </Box>
                        <Box gridColumn="span 1">
                            <p className='text-subHeading-2 text-[hsl(var(--primary))] font-bold'>RootCause</p>
                            <p>{formData?.rootCause}</p>
                        </Box>

                    </Box>
                    <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(2, 1fr)" gap={2}>
                        <Box gridColumn="span 1">
                            <div className="relative" style={{ marginBottom: '2%' }}>
                                <Textarea className={cn('ml-[0px]')} label="What went wrong (Challenges)" rules={{
                                    validate: (value) => {
                                        if (!value) return t('This field is required')
                                        if (value.length > 251) return t('Character count should not exceed 250')
                                        return true
                                    }
                                }} register={register} value={formData?.wrong} type="text" placeholder="Enter What went wrong (Challenges)" onValueChange={(e) => { onInputChange('wrong', e, 'textarea') }} name="wrong" errors={errors} control={control} required maxLength={250} />
                                <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.wrong?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.wrong?.length || 0}/250</div>
                            </div>
                        </Box>
                        <Box gridColumn="span 1">
                            <div className="relative" style={{ marginBottom: '2%' }}>
                                <Textarea className={cn('ml-[0px]')} label="What went right (Successes)" rules={{
                                    validate: (value) => {
                                        if (!value) return t('This field is required')
                                        if (value.length > 251) return t('Character count should not exceed 250')
                                        return true
                                    }
                                }} register={register} value={formData?.right} type="text" placeholder="Enter What went right (Successes)" onValueChange={(e) => { onInputChange('right', e, 'textarea') }} name="right" errors={errors} control={control} required maxLength={250} />
                                <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.right?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.right?.length || 0}/250</div>
                            </div>
                        </Box>
                    </Box>
                    <Box display="grid" sx={{ pb: 2 }} gridTemplateColumns="repeat(2, 1fr)" gap={2}>
                        <Box gridColumn="span 1">
                            <div className="relative" style={{ marginBottom: '2%' }}>
                                <Textarea className={cn('ml-[0px]')} label="What needs to be improved" rules={{
                                    validate: (value) => {
                                        if (!value) return t('This field is required')
                                        if (value.length > 251) return t('Character count should not exceed 250')
                                        return true
                                    }
                                }} register={register} value={formData?.improved} type="text" placeholder="Enter Impact/Probability Justification" onValueChange={(e) => { onInputChange('improved', e, 'textarea') }} name="impactProbabilityJustification" errors={errors} control={control} required maxLength={250} />
                                <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.improved?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.improved?.length || 0}/250</div>
                            </div>
                        </Box>
                    </Box>

                </div>
                { <div className="h-[10%] flex justify-end items-center space-x-4">
                    <Button
                        onClick={() => handleCancel()}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    >
                        <RxCross2 className="mr-2" size={18} /> {t('Cancel')}
                    </Button>
                    <Button onClick={() => onSubmit('Mitigation stage has been completed for Risk [ID]')} disabled={loading}>
                        <LiaSaveSolid className="mr-2" size={15} /> Save
                    </Button>
                </div>}
            </Card>
        </div>
    )
}

export default IssuePendingEdit
